import { Text } from "../../../../../components/general/Text";
import TimeHelper from "../../../../../helpers/TimeHelper";
import { LocationStatus } from "../../../../../interfaces/StayInterface";

type EnterLeaveTimeInfoProps = {
  time: string;
  status: LocationStatus | null;
  buildingName: string | null;
};

export const EnterLeaveTimeInfo = ({
  time,
  status,
  buildingName,
}: EnterLeaveTimeInfoProps) => {
  const formattedTime = time ? TimeHelper.fullFormat(time) : "";

  let statusText = "";
  if (time) {
    switch (status) {
      case "outside":
        statusText = "（範囲外）";
        break;
      case "inside":
        statusText = `（${buildingName}）`;
        break;
      case "unable_to_locate":
        statusText = "（座標取得不可）";
        break;
      case "indeterminable":
        statusText = "（座標判定不可）";
        break;
    }
  }
  return <Text align="center">{`${formattedTime}${statusText}`}</Text>;
};
